import React from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import * as request from 'services/request'
import notify from 'utils/notification'
import MediaLoading from 'pages/widgets/form/tweet-input/media/media-loading'
const { pipe, split, last, toLower, head } = require('ramda')

class OverlayPreviewModal extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      id: props.id ? props.id[0] : null,
      media: null,
      loading: true,
      error: false
    }
    this.closeModal = this.closeModal.bind(this)
  }

  closeModal () {
    this.setState({ show: false })

    const { close } = this.props

    setTimeout(() => {
      close()
      this.setState({
        show: true,
        loading: true
      })
    }, 500)
  }

  componentDidUpdate (prevProps) {
    // only get media when showing modal, not when closing it
    if (
      prevProps.showPreview !== this.props.showPreview &&
      this.props.id &&
      this.props.showPreview
    ) {
      this.getOverlayPreview()
    }
  }

  async getOverlayPreview () {
    const { id, actionType } = this.props

    const type = pipe(split('_'), last, toLower)(actionType)

    if (!id || !actionType) return

    const idString = head(id)

    this.setState({
      loading: true
    })

    try {
      const response = await request.authorized(
        `/overlay/preview/${type}/${idString}`
      )

      const previewId = await response.text()
      const responsePreview = await request.authorized(`/media/${previewId}`)

      let preview
      let previewUrl
      switch (type) {
        case 'image':
          preview = await responsePreview.blob()
          previewUrl = window.URL.createObjectURL(preview)
          break
        case 'gif':
          preview = await responsePreview.json()
          previewUrl = head(preview)
          break
        default:
          return
      }

      this.setState({
        media: previewUrl,
        loading: false
      })
    } catch (error) {
      notify.error({
        title: `Error loading media`,
        message: `Could not load media id '${id}': ${error.message}`
      })
    }
  }

  render () {
    const { loading } = this.state
    const { id, actionType } = this.props

    if (!id || !actionType) return null

    let media = null

    if (loading) {
      media = (
        <MediaLoading className='br-media-loading'>
          <div className='lds-ellipsis'>
            <div />
            <div />
            <div />
            <div />
          </div>
        </MediaLoading>
      )
    } else {
      media = (
        <img
          src={this.state.media}
          alt={`${actionType}-${id}`}
          className='br-media-preview-area'
        />
      )
    }

    return (
      <Modal show={this.props.showPreview} onHide={this.closeModal}>
        <Modal.Header closeButton>
          <Modal.Title>Overlay Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body className='br-media-preview-modal'>{media}</Modal.Body>
      </Modal>
    )
  }
}

OverlayPreviewModal.propTypes = {
  id: PropTypes.array,
  actionType: PropTypes.string,
  close: PropTypes.func,
  showPreview: PropTypes.bool
}

export default OverlayPreviewModal



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/actions/twitter/send-overlay/overlay-attachments/components/overlay-preview.js